/**
 * Traduce el error de la API al mensaje que ve el administrador.
 * El backend responde con `{ statusCode, message, error }`.
 */

interface ApiErrorShape {
  response?: {
    data?: {
      message?: string | string[];
    };
  };
  message?: string;
}

export function describeError(cause: unknown): string {
  const error = cause as ApiErrorShape;
  const apiMessage = error?.response?.data?.message;

  if (Array.isArray(apiMessage)) return apiMessage.join('. ');
  if (typeof apiMessage === 'string') return apiMessage;
  if (typeof error?.message === 'string') return error.message;

  return 'Ocurrio un error inesperado';
}
